import { render, staticRenderFns } from "./znPartTimePositionApproveDetail.vue?vue&type=template&id=057bae88&scoped=true&"
import script from "./znPartTimePositionApproveDetail.vue?vue&type=script&lang=js&"
export * from "./znPartTimePositionApproveDetail.vue?vue&type=script&lang=js&"
import style0 from "./znPartTimePositionApproveDetail.vue?vue&type=style&index=0&id=057bae88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057bae88",
  null
  
)

export default component.exports